import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FC } from 'react';
import { Button, RHFTextField } from '@higo/ui';
import { FormattedMessage } from 'react-intl';
import { object, ref, string } from 'yup';
import { setYupDefaultMessages } from 'config/yupLocale';

setYupDefaultMessages();
const schema = object({
  pin: string().required().min(6),

  pinConfirmation: string()
    .required()
    .oneOf([ref('pin')], 'validation.pinMatch'),
});

export interface SetNewPinFormModel {
  pin: string;
  pinConfirmation: string;
}

const defaultValues: SetNewPinFormModel = {
  pin: '',
  pinConfirmation: '',
};

export type SetNewPinFormProps = {
  onSubmit: (value: SetNewPinFormModel) => Promise<unknown>;
};

export const SetNewPinNumberForm: FC<SetNewPinFormProps> = ({ onSubmit }) => {
  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useForm<SetNewPinFormModel>({
    defaultValues,
    resolver: yupResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <RHFTextField
        control={control}
        type="password"
        label="common.pin"
        name="pin"
        id="new-pin-field"
      />
      <RHFTextField
        control={control}
        type="password"
        label="common.pinConfirmation"
        name="pinConfirmation"
        id="pin-confirm-field"
      />
      <Button
        type="submit"
        disabled={isSubmitting}
        isLoading={isSubmitting}
        fullWidth
        id="submit-button"
      >
        <FormattedMessage id="authentication.setPinCode.savePinCode" />
      </Button>
    </form>
  );
};
